export function hello (s) {
  //return "Typescript: " + s;
  return s;
}
